import Result from './result.vue';
export default Result;


// WEBPACK FOOTER //
// ./src/components/result/index.js